import aiApi from '@/api/aiApi.ts'
import type { Student } from '@/dto'

class AiController {
  getSessionId = async () => {
    const {
      data: { sessionId },
    } = await aiApi.getSessionId()

    return sessionId
  }

  createAiComment = async (
    sessionId: string,
    studentId: Student['id'],
    payload: req.CreateAiComment,
  ) => {
    return await aiApi.createAiComment(sessionId, studentId, payload)
  }

  createReportComment = async (payload: req.CreateReportComment, signal?: AbortSignal) => {
    const { data } = await aiApi.createReportComment(payload, signal)
    return data
  }
}

export const aiController = new AiController()
